export const QUOTE_PROGRESSION_STATUS = {
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  PUBLISHED: 'PUBLISHED',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE',
  SENT: 'SENT',
  SENT_PENDING_SIGNATURE: 'SENT_PENDING_SIGNATURE',
  VIEWED: 'VIEWED',
  VIEWED_PENDING_SIGNATURE: 'VIEWED_PENDING_SIGNATURE',
  NEEDS_COUNTERSIGN: 'NEEDS_COUNTERSIGN',
  ACCEPTED: 'ACCEPTED'
};
const DISPLAY_CONFIG = {
  [QUOTE_PROGRESSION_STATUS.DRAFT]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.draft',
    use: 'draft'
  },
  [QUOTE_PROGRESSION_STATUS.PENDING_APPROVAL]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.pendingApproval',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.CHANGES_REQUESTED]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.changesRequested',
    use: 'error'
  },
  [QUOTE_PROGRESSION_STATUS.PUBLISHED]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.published',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.PENDING_SIGNATURE]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.pendingSignature',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.SENT]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.sent',
    use: 'sent'
  },
  [QUOTE_PROGRESSION_STATUS.SENT_PENDING_SIGNATURE]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.sentPendingSignature',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.VIEWED]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.viewed',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.VIEWED_PENDING_SIGNATURE]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.viewedPendingSignature',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.NEEDS_COUNTERSIGN]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.needsCounterSign',
    use: 'inReview'
  },
  [QUOTE_PROGRESSION_STATUS.ACCEPTED]: {
    lyamlKey: 'growthPaymentsCore.progressionStatus.accepted',
    use: 'success'
  }
};
export const useQuoteProgressionStatusDisplayConfig = quoteProgressionStatus => quoteProgressionStatus && quoteProgressionStatus in DISPLAY_CONFIG ? DISPLAY_CONFIG[quoteProgressionStatus] : {
  lyamlKey: null
};